<div class="homeSideBar">
    <div class="homeLoginArea">
        <span class="homeSideBarHeader" [innerHTML]="'ACCOUNT_REGISTER_TITLE' | translate"></span>
        <div class="departureTimeListArea">
            <ul class="nav nav-tabs" style="border-bottom: 0px"  *ngIf="loginTypes.length > 1">
                <li *ngFor="let loginType of loginTypes" [class.active]="obLogin.loginType == loginType.type">
                    <a data-toggle="tab" (click)="changeLoginType(loginType.type)" [innerHTML]="loginType.translateKey | translate" type="button"></a>
                </li>
            </ul>
            <div class="tab-content">
                <!-- <div class="phoneLogin" class="tab-pane" [class.active]="obLogin.loginType == 'phone'">
                    <p class="formPagesInfoText ng-binding" [innerHTML]="'ACCOUNT_REGISTER_PHONE_DESCRIPTION' |translate"></p>
                    <div class="phoneNumberWrapper">
                        <div class="registerPhoneArea" style="border:solid 1px gray; padding: 0px 5px 2px 5px; width:275px; height: 48px;margin-bottom: 100px;">
                            <span>+90</span> <span class="inputLine"></span>  
                        </div>
                        <input class="formInput formInputWithPhone phoneNumberWrapperInputs" type="tel" phoneMask maxlength="15" [(ngModel)]="phoneNumber" [placeholder]="'ACCOUNT_LOGIN_PHONE_INPUT_PLACEHOLDER' | translate" required>
                    </div>
                    <br>
                    <a type="button" class="formButton" (click)='obSubmit()' [innerHTML]="'ACCOUNT_REGISTER_REGISTER_BUTTON' | translate"></a>
                    <span class="spacer20"></span>
                </div> -->
                <div class='emailLogin' class="tab-pane" [class.active]="obLogin.loginType == 'email'">
                    <p class="formPagesInfoText ng-binding" [innerHTML]="'ACCOUNT_REGISTER_EMAIL_DESCRIPTION' |translate"></p>
                    <div class="phoneNumberWrapper">
                        <div class="registerPhoneArea" style="border:solid 1px gray; padding: 0px 5px 2px 5px; width:275px; height: 48px;margin-bottom: 100px;">
                            <span class="inputLine"></span>  
                        </div>
                        <input class="formInput phoneNumberWrapperInputs" type="email"  [(ngModel)]="obLogin.email" [placeholder]="'ACCOUNT_LOGIN_EMAIL_INPUT_PLACEHOLDER' | translate" required>
                    </div>
                    <br>
                    <a type="button" class="formButton" (click)='obSubmit()' [innerHTML]="'ACCOUNT_REGISTER_REGISTER_BUTTON' | translate"></a>
                </div>
            </div>
        </div>
    </div>
    <app-download-app></app-download-app>
</div>